import React from 'react';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import withApollo from '../lib/apollo';
import profilesConnectionQuery
from '../lib/queries/products/profilesConnectionQuery.graphql';
import DirectoryList from '../components/DirectoryPage/List';
import { DirectoryPage, DirectoryLayout } from '../components/DirectoryPage';
import messages from '../lib/messages.mjs';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import {
  directoryCardImageConfigurations,
  directoryCardLogoConfigurations,
} from '../lib/imageConfigurations';

const headerImageUrls = {
  mobile: [
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=34,quality=10,width=42/https://media.fashionunited.com/media/software1.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=288,quality=70,width=360/https://media.fashionunited.com/media/software1.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=576,quality=70,width=720/https://media.fashionunited.com/media/software1.jpg',
  ],
  desktop: [
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=8,quality=10,width=42/https://media.fashionunited.com/media/software1.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=277,quality=70,width=1350/https://media.fashionunited.com/media/software1.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=526,quality=70,width=2560/https://media.fashionunited.com/media/software1.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=1052,quality=70,width=5120/https://media.fashionunited.com/media/software1.jpg',
  ],
};

export const SoftwareSuppliersDirectoryPage = () => {
  const intl = useIntl();
  const {
    query: {
      country,
      section,
      search,
    },
  } = useRouter();

  const SOFTWARE_SUPPLIERS_LIMIT = 20;

  return (
    <DirectoryPage
      title={intl.formatMessage(messages['software-suppliers-directory.title'])}
      route="software-suppliers-directory"
      pageType="software-suppliers"
      ComponentWithQuery={DirectoryList}
      variables={{
        type: 'SOFTWARE_SUPPLIER',
        first: SOFTWARE_SUPPLIERS_LIMIT,
        search,
        premium: section !== 'all' || null,
        country: country || null,
        imageConfigurations: directoryCardImageConfigurations,
        logoConfigurations: directoryCardLogoConfigurations,
      }}
      query={profilesConnectionQuery}
    />
  );
};

SoftwareSuppliersDirectoryPage.getLayout = (page) => (
  <DirectoryLayout
    imageUrls={headerImageUrls}
    alt="FashionUnited Software Suppliers Directory"
  >
    {page}
  </DirectoryLayout>
);

SoftwareSuppliersDirectoryPage.getInitialProps = redirectRouteToDomain(
  'software-suppliers-directory',
);

export default withApollo(SoftwareSuppliersDirectoryPage);
